export default function isUpdateWorkflowNavigation(step) {
    let isUpdate = false
    switch (step) {
        case "upload":
        case "transcription":
        case "generate_all_ecp":
        case "finalize":
            isUpdate = true
            break
        case "chunking":
        case "abstract":
        case "summary":
        case "keypoints":
        case "verbatims":
        case "glossary":
            isUpdate = false
            break
        default:
            break
    }
    return isUpdate
}